import { z } from 'zod';

export const ReportTargetTypeSchema = z.enum(['comment', 'post', 'user']);
export type ReportTargetType = z.infer<typeof ReportTargetTypeSchema>;

export const ReportReasonSchema = z.enum(['spam', 'inappropriate', 'harassment', 'other']);
export type ReportReason = z.infer<typeof ReportReasonSchema>;

export const CreateReportPayloadSchema = z.object({
  targetType: ReportTargetTypeSchema,
  targetId: z.string().min(1),
  targetUserId: z.string().min(1),
  reason: ReportReasonSchema,
  postId: z.string().optional(),
});

export type CreateReportPayload = z.infer<typeof CreateReportPayloadSchema>;
